import { EventCallToAction, EventContentStatus } from 'globalTypes'

import Button from 'Root/App/Button'
import { useCurrentUserId } from 'lib/use-current-user-id'
import size from 'lodash/size'
import { useRouter } from 'next/router'

import AddRegistration from './AddRegistration'
import RemoveRegistration from './RemoveRegistration'

interface EventContentRegistration extends EventCallToAction {
  title: string
  slug: string
}

interface Props {
  content: EventContentRegistration
}

const CallToAction = ({ content }: Props) => {
  const router = useRouter()
  const currentUserId = useCurrentUserId()

  if (content.status === EventContentStatus.expired) {
    return null
  }

  if (content.registration) {
    if (!Boolean(currentUserId)) {
      return (
        <Button anchor to={`/login?returnUrl=${router.asPath}`}>
          Accedi per registrarti{' '}
          {router.query.identifier === '64O6b-KfBYo' && 'GRATIS'}
        </Button>
      )
    }

    const canRegister =
      !content.isCurrentUserRegistered &&
      content.status === EventContentStatus.scheduled &&
      (!content.participants ||
        size(content.registeredUsers) < content.participants) &&
      !content.canManage

    if (canRegister) {
      return <AddRegistration content={content} />
    }
  }

  if (
    !(Boolean(content.url) && content.status !== EventContentStatus.past) &&
    !content.isCurrentUserRegistered
  ) {
    return null
  }

  function handleRemoveRender() {
    if (content.registration) {
      if (content.isCurrentUserRegistered) {
        return <RemoveRegistration content={content} />
      }
    }
    return null
  }

  return (
    <div className="flex flex-col gap-y-1 py-3">
      {Boolean(content.url) && content.status !== EventContentStatus.past && (
        <Button anchor target="_blank" to={content.url}>
          Accedi all&apos;evento
        </Button>
      )}
      {handleRemoveRender()}
    </div>
  )
}

export default CallToAction
